// Reservation Policies translations for React Admin resource
export const reservationPoliciesResource = {
  name: '預約政策',
  fields: {
    id: '編號',
    name: '政策名稱',
    description: '說明',
    isSystemDefault: '系統預設',
    reservationMode: '預約模式',
    accessMode: '存取模式',
    feePolicy: '費用政策',
    slotDurationMinutes: '時段長度（分鐘）',
    slotGranularityMinutes: '時段刻度（分鐘）',
    holdWindowMinutes: '保留時間（分鐘）',
    leadTimeMinutes: '提前預約時間（分鐘）',
    cancelWindowMinutes: '取消期限（分鐘）',
    modifyWindowMinutes: '修改期限（分鐘）',
    maxAdvanceDays: '最長預約天數',
    maxActivePerUser: '每位用戶最大同時數',
    maxModifications: '最多修改次數',
    liveStatusHorizonHours: '即時狀態保護時段（小時）',
    blockedNoshowToleranceMinutes: '被前車阻擋容忍時間（分鐘）',
    forfeitOnBlockedNoShow: '被阻擋仍沒收押金',
    blockedDetectionIncrementMinutes: '每次偵測累計分鐘數',
    allowedMembershipLevels: '允許會員等級',
    allowedGroupIds: '允許用戶群組',
    createdAt: '建立時間',
    updatedAt: '更新時間',
    createdBy: '建立者',
    updatedBy: '更新者',
  },
};

// Custom reservation-policies translations for components
export const reservationPolicies = {
  subtitle: '可重複使用的預約行為預設',
  list: {
    title: '預約政策',
    subtitle: '所有預約政策',
    searchPlaceholder: '搜尋政策',
    noPolicies: '尚未定義預約政策',
    filters: {
      search: '搜尋',
    },
  },
  create: {
    title: '建立預約政策',
    subtitle: '定義新的預約政策預設',
    backToList: '返回政策列表',
  },
  edit: {
    title: '編輯預約政策',
    subtitle: '修改政策設定',
    backToList: '返回政策列表',
  },
  show: {
    subtitle: '政策詳情',
  },
  sections: {
    identity: '識別資料',
    timing: '模式',
    timingWindows: '時間設定',
    feeBehavior: '費用行為',
    eligibility: '資格條件',
  },
  banners: {
    presetLibrary: '政策為可重複使用的預設。請在充電器的費率模板中選擇此政策以套用。',
    feeBehavior: '費用金額於費率模板中針對充電器個別設定。此政策僅定義費用的行為（釋放、抵扣充電費用或失約沒收）。',
  },
  modes: {
    fixed_slot: '固定時段',
    next_slot: '下一時段',
  },
  accessModes: {
    reservation_only: '僅限預約',
    reserve_or_fcfs: '預約或先到先用',
  },
  feePolicies: {
    none: '免費',
    hold_release: '凍結並釋放',
    hold_apply: '凍結並抵扣',
    hold_forfeit_on_noshow: '凍結（失約則沒收）',
  },
  feePolicyTooltips: {
    none: '不收取預約費用。',
    hold_release: '預約時自錢包凍結費用；無論充電完成或失約均會釋放。',
    hold_apply: '預約時自錢包凍結費用；作為充電費用之預付。',
    hold_forfeit_on_noshow: '預約時自錢包凍結費用；準時到場則釋放，失約則沒收。',
  },
  membershipLevels: {
    standard: '標準',
    silver: '銀卡',
    gold: '金卡',
    platinum: '白金',
    vip: 'VIP',
  },
  validation: {
    nameRequired: '政策名稱為必填',
    durationTooShort: '時段長度最少 15 分鐘',
    granularityInvalid: '時段刻度需可整除時段長度',
    holdWindowTooShort: '保留時間最少 5 分鐘',
    leadTimeNegative: '提前預約時間不可為負',
  },
  helpers: {
    name: '此政策預設的唯一名稱',
    description: '選填，供內部參考的說明',
    systemDefaultName: '系統預設名稱不可更改',
    reservationMode: '固定時段使用預設窗口；下一時段預約下一可用區段',
    accessMode: '限制預約時段的使用權或允許非預約用戶使用',
    accessModeFixedSlot: '固定時段政策僅限預約使用：不允許非預約用戶，以免未預約的充電延續佔用已預約的時段。',
    slotDuration: '每個預約區段的長度。',
    slotDurationDisabled: 'next_slot 模式下不適用，會改用 Hold Window 作為時段長度。',
    naNextSlot: 'next_slot 模式下不適用。預約自「現在」開始，此時段設定無意義。',
    slotGranularity: '時段邊界的最小遞增單位（須可整除時段長度）',
    holdWindow: '逾開始時間後仍保留時段的時間長度',
    leadTime: '最早可預約的提前時間',
    cancelWindow: '時段開始前可取消的時限',
    modifyWindow: '時段開始前可修改的時限',
    maxAdvanceDays: '可預約的最長提前天數',
    maxActivePerUser: '每位用戶可同時存在的預約數',
    maxModifications: '每張預約可修改的次數上限',
    liveStatusHorizonHours: '在此小時數內的預約時段會檢查充電樁當下的 OCPP 狀態（離線／故障／維護／停用），超出此時段則忽略狀態。可避免短暫斷線影響遠期預約。預設為 2。',
    feePolicy: '預約費用的處理方式',
    blockedNoshowTolerance: '若用戶在保留時段內被前一位佔用充電樁的用戶阻擋達此分鐘數，仍標記為未到場，但押金會釋放而不沒收。預設 5 分鐘。',
    forfeitOnBlockedNoShow: '嚴格模式：即使是被前一位用戶阻擋導致未到場，仍沒收押金。預設關閉。',
    blockedDetectionIncrement: '每分鐘偵測排程觀察到充電樁仍被佔用時，累計到「被阻擋分鐘數」的數值。預設 1（每次累計 1 分鐘）。設為 0 即停用此政策的等待累計。',
    allowedMembershipLevels: '限制特定會員等級（留白即所有等級皆可）',
    allowedGroupIds: '限制特定群組成員（留白即無群組限制）',
  },
  notifications: {
    created: '預約政策已成功建立',
    updated: '預約政策已成功更新',
    deleted: '預約政策已成功刪除',
    error: {
      create: '建立政策失敗',
      update: '更新政策失敗',
      delete: '刪除政策失敗',
    },
  },
  actions: {
    create: '建立政策',
    save: '儲存變更',
    delete: '刪除政策',
  },
};

export const reservationPoliciesTranslations = {
  'reservation-policies': {
    ...reservationPoliciesResource,
    ...reservationPolicies,
  },
};
